import { LoggerFactory } from '@cvent/logging/LoggerFactory';
import { COOKIE_LOCALE_NAME, getEventLocaleCookieWithExpirationTime } from '../../locales';
import { setCookieHeader } from './setCookieHeader';

const LOG = LoggerFactory.create('locale');

/**
 * @description Used to set cookie at server side.
 * @param {Object} context
 * @param {string} eventId
 * @param {string} locale
 */
export const setLocaleCookieUsingContext = (context, eventId, locale) => {
  LOG.debug(`Resolving locale to ${locale}`);
  const localeCookieValue = context.req.cookies[COOKIE_LOCALE_NAME];

  setCookieHeader(context.res, [getEventLocaleCookieWithExpirationTime(localeCookieValue, eventId, locale)]);
};
